import React, {cloneElement, Component} from 'react'
import propTypes from 'prop-types'

const styles = {
  root: {
    display: 'inline',
  },
}

class Draggable extends Component {
  state = {
    active: false,
  }

  mouseDown = (e) => {
    const {active, data, minDistance, axis, children, onStart, onDrag, onDrop} = this.props
    let {previewElement} = this.props

    if (active && this.context.dragLayer) {
      let previewWidth, previewHeight

      if (previewElement === null && children && !Array.isArray(children)) {
        const offset = this.root.getBoundingClientRect()
        previewWidth = offset.width
        previewHeight = offset.height
        previewElement = cloneElement(children, {isDragPreview: true})
      }

      this.context.dragLayer.startDrag({
        data,
        element: this.root,
        x: e.clientX,
        y: e.clientY,
        previewElement,
        previewWidth,
        previewHeight,
        minDistance,
        axis,
        onStart: (...p) => {
          this.setState({active: true})
          if (onStart) onStart(...p)
        },
        onDrag,
        onDrop: (...p) => {
          this.setState({active: false})
          if (onDrop) onDrop(...p)
        },
      })
    }

    e.preventDefault()
    e.stopPropagation()
    return false
  }

  render() {
    const {placeholderElement, style, manualDrag, title, className} = this.props
    let {children} = this.props
    const {active} = this.state

    if (active) {
      children = placeholderElement ||
        (children && !Array.isArray(children)
            ? cloneElement(children, {isDragPlaceholder: true})
            : null
        )
    } else if (children && manualDrag) {
      children = cloneElement(children, {onStartDrag: this.mouseDown})
    }

    const onMouseDown = manualDrag ? null : this.mouseDown

    return (
      <div
        className={`draggable ${className}`}
        style={{...styles.root, ...style}}
        ref={e => this.root = e}
        onMouseDown={onMouseDown}
        title={title}
      >
        {children}
      </div>
    )
  }
}

Draggable.propTypes = {
  active: propTypes.bool,
  data: propTypes.any,
  minDistance: propTypes.number,
  axis: propTypes.oneOf(['x', 'y']),
  previewElement: propTypes.element,     // the element being displayed under the cursor whilst dragging
  placeholderElement: propTypes.element, // the element to display in the original element's position whilst dragging
  manualDrag: propTypes.bool,         // specify true to initiate drag yourself via the injected onStartDrag callback
  title: propTypes.string,
  onStart: propTypes.func,
  onDrag: propTypes.func,
  onDrop: propTypes.func,
  children: propTypes.any,
  style: propTypes.object,
  className: propTypes.string,
}

Draggable.defaultProps = {
  active: true,
  minDistance: 5,
  restrictToParent: false,
  manualDrag: false,
  previewElement: null,
  className: '',
}

Draggable.contextTypes = {
  dragLayer: propTypes.object.isRequired,
}

export default Draggable
